<template>
  <div>
    <a-drawer
      title="Create a new webhook"
      width="60%"
      @close="onClose"
      :visible="isDrawerVisible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
      <a-spin size="large" :spinning="loading">
        <a-form :form="form" :layout="formLayout" style="margin-top:1em;" class="create_tenant">
          <a-url-field
            varName="url"
            varLabel="Webhook URL"
            :varRequired="true"
            :formLayout="formLayout"
            :size="size"
            icon="link"
          />
          <a-select-field
            :formLayout="formLayout"
            :size="size"
            varName="event"
            varLabel="Event Type"
            :varRequired="true"
            type="schema"
            :varOptions="Events"
            description="Event type to trigger the webhook"
          />
          <a-submit-button
            @submit="handleSubmit"
            :formLayout="formLayout"
            btn_text="Create Webhook"
            styled="margin-top:0.5em;"
          />
        </a-form>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import Events from "@/configs/WebhookEvents.js";
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: "vertical",
      size: "large",
      loading: false,
      Events
    };
  },
  methods: {
    onClose() {
      this.$store.dispatch("ui/hideDrawer", {
        drawer_name: "create_webhook"
      });
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true;
            await this.$store.dispatch("tenant/createItem", {
              endpoint: "webhooks",
              data: values
            });
            this.loading = false;
            await this.$store.dispatch("ui/hideDrawer", {
              drawer_name: "create_webhook"
            });
            await this.$store.dispatch("tenant/getItems", {
              endpoint: "webhooks"
            });
            await this.$notification.open({
              message: "New webhook created!",
              description: "Please configure your webhook receiver.",
              icon: (
                <a-icon
                  type="check-circle"
                  theme="filled"
                  style="color: green"
                />
              )
            });
          } catch (error) {
            console.error(error);
            this.loading = false;
            let errorConfig = {};
            if (error.response.data.hasOwnProperty("url")) {
              errorConfig["url"] = {
                value: values.url,
                errors: [new Error(`${error.response.data.url}`)]
              };
            }
            if (error.response.data.hasOwnProperty("event")) {
              errorConfig["event"] = {
                value: values.event,
                errors: [new Error(`${error.response.data.event}`)]
              };
            }
            form.setFields(errorConfig);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },
  computed: {
    isDrawerVisible() {
      return this.$store.state.ui.create_webhook;
    }
  }
};
</script>
